import { useContext } from 'react';
import { Context, setLoggedIn } from './userProvider';

export const useSetIsLoggedIn = () => {
    const { dispatch } = useContext(Context);
    return function setIsLoggedIn(isLoggedIn: boolean) {
        dispatch(setLoggedIn(isLoggedIn));
    };
};
